import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import App from './App'
import PublicApply from './pages/PublicApply'
import PublicRegister from './pages/PublicRegister'
import ResetPassword from './pages/ResetPassword'
import { LanguageProvider } from './contexts/LanguageContext'
import './index.css'
import './styles/globals.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/apply/:token" element={<PublicApply />} />
          <Route path="/register" element={<PublicRegister />} />
          <Route path="/register/:token" element={<PublicRegister />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="*" element={<App />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  </React.StrictMode>,
)
